import React, { useState } from "react";
import { makeStyles, lighten } from "@material-ui/core/styles";
import { Paper, Typography, Box } from "@material-ui/core";
import { HelpOutline, LocalMovies, Description } from "@material-ui/icons";
import EditMediaModal from "./EditMediaModal";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
  },
  listElementContainer: {
    textAlign: "center",
    marginInline: theme.spacing(2),
  },
  paper: {
    width: 100,
    height: 100,
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
    marginBlock: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  selected: {
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
  },
  fileName: {
    fontSize: "12px",
    maxWidth: 100,
  },
  imageContainer: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

const MediaListElement = ({
  listElement,
  selectMode,
  handleSelect,
  selectedItem,
  imageSelector,
  handleClose,
  gallerySelctor,
  gallerySlected,
  handleSelectGallery,
}) => {
  const [openDetailsModal, setopenDetailsModal] = useState(false);

  function shortenFilename(filename, maxLength) {
    if (filename.length <= maxLength) return filename;

    const prefixLength = Math.ceil((maxLength - 3) / 2);
    const suffixLength = Math.floor((maxLength - 3) / 2);

    return (
      filename.substr(0, prefixLength) +
      "..." +
      filename.substr(filename.length - suffixLength)
    );
  }

  const imageExtensions = ["jpg", "jpeg", "png", "gif"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv"];
  const documentExtensions = ["pdf", "doc", "docx", "txt"];

  const GetFileType = (extension) => {
    let fileType = "";
    if (imageExtensions.includes(extension)) {
      fileType = "image";
    } else if (videoExtensions.includes(extension)) {
      fileType = "video";
    } else if (documentExtensions.includes(extension)) {
      fileType = "document";
    } else {
      fileType = "document";
    }
    return fileType;
  };

  const classes = useStyles();
  const extension = listElement.name
    .split(".")
    .pop()
    .toLowerCase();

  const handleCloseDetailModal = () => {
    setopenDetailsModal(false);
  };

  let fileTypeIcon = <HelpOutline fontSize="large" color="disabled" />;
  if (imageExtensions.includes(extension)) {
    fileTypeIcon = (
      <img
        crossOrigin="anonymous"
        className={classes.imageContainer}
        src={`${baseUrl}file/get/128-${listElement.name}?thumbnail=true`}
        alt={listElement.name}
      />
    );
  } else if (videoExtensions.includes(extension)) {
    fileTypeIcon = <LocalMovies fontSize="large" color="disabled" />;
  } else if (documentExtensions.includes(extension)) {
    fileTypeIcon = <Description fontSize="large" color="disabled" />;
  } else {
    fileTypeIcon = <HelpOutline fontSize="large" color="disabled" />;
  }

  const handleClick = () => {
    if (selectMode) {
      if (gallerySelctor) {
        handleSelectGallery(listElement);
        setTimeout(() => {
          handleClose();
        }, 500);
      } else {
        handleSelect(listElement.name);
        setTimeout(() => {
          handleClose();
        }, 500);
      }
    } else {
      setopenDetailsModal(true);
    }
  };

  return imageSelector ? (
    imageExtensions.includes(extension) ? (
      <>
        <Box className={classes.listElementContainer}>
          <Paper
            elevation={4}
            className={`${classes.paper} ${
              selectedItem === listElement.name ? classes.selected : ""
            }`}
            onClick={handleClick}
          >
            {fileTypeIcon}
          </Paper>
          <Typography className={classes.fileName}>
            {shortenFilename(listElement.name, 17)}
          </Typography>
        </Box>
        <EditMediaModal
          open={openDetailsModal}
          handleClose={handleCloseDetailModal}
          mediaData={listElement}
          mediaType={GetFileType(extension)}
          mediaExtention={extension}
        />
      </>
    ) : null
  ) : gallerySelctor ? (
    imageExtensions.includes(extension) ||
    videoExtensions.includes(extension) ? (
      <>
        <Box className={classes.listElementContainer}>
          <Paper
            elevation={4}
            className={`${classes.paper} ${
              gallerySlected?._id === listElement._id ? classes.selected : ""
            }`}
            onClick={handleClick}
          >
            {fileTypeIcon}
          </Paper>
          <Typography className={classes.fileName}>
            {shortenFilename(listElement.name, 17)}
          </Typography>
        </Box>
        <EditMediaModal
          open={openDetailsModal}
          handleClose={handleCloseDetailModal}
          mediaData={listElement}
          mediaType={GetFileType(extension)}
          mediaExtention={extension}
        />
      </>
    ) : null
  ) : (
    <>
      <Box className={classes.listElementContainer}>
        <Paper
          elevation={4}
          className={`${classes.paper} ${
            selectedItem === listElement.name ? classes.selected : ""
          }`}
          onClick={handleClick}
        >
          {fileTypeIcon}
        </Paper>
        <Typography className={classes.fileName}>
          {shortenFilename(listElement.name, 17)}
        </Typography>
      </Box>
      <EditMediaModal
        open={openDetailsModal}
        handleClose={handleCloseDetailModal}
        mediaData={listElement}
        mediaType={GetFileType(extension)}
        mediaExtention={extension}
      />
    </>
  );
};

export default MediaListElement;
